import {useEffect,useSyncExternalStore} from 'react';
import {audioSettings,unlockAudio,playSound} from '../audio/gameAudio';
export function AudioControls(){
 const settings=useSyncExternalStore(audioSettings.subscribe,audioSettings.get,audioSettings.get);
 useEffect(()=>{
  const unlock=()=>unlockAudio();
  window.addEventListener('pointerdown',unlock);window.addEventListener('keydown',unlock);
  return ()=>{window.removeEventListener('pointerdown',unlock);window.removeEventListener('keydown',unlock);};
 },[]);
 return <details className="audio-controls" onKeyDown={e=>e.stopPropagation()} onKeyUp={e=>e.stopPropagation()}>
  <summary aria-label="Audio settings">{settings.enabled&&settings.volume>0?'♫ Sound':'♫ Muted'}</summary>
  <div className="audio-popover"><strong>Sound effects</strong>
   <label><input type="checkbox" checked={settings.enabled} onChange={e=>{audioSettings.set({enabled:e.target.checked});unlockAudio();}}/> Enable sound</label>
   <label>Volume {Math.round(settings.volume*100)}%<input aria-label="Sound volume" type="range" min="0" max="100" value={Math.round(settings.volume*100)} onChange={e=>audioSettings.set({volume:Number(e.target.value)/100})}/></label>
   <button disabled={!settings.enabled||settings.volume===0} onClick={()=>{unlockAudio();playSound('confirm');}}>Test sound</button><small>Saved automatically.</small>
  </div>
 </details>;
}
